import { defineMessages } from 'react-intl'

export default defineMessages({
  pronunciation: {
    id: 'containers.CustomerOrderUpsertPage.components.Memories.pronunciation',
    defaultMessage: 'Add pronunciation',
  },
})